export enum ButtonType {
  Button = 'button',
  Submit = 'submit',
  Link = 'link',
  Reset = 'reset',
}

export enum ButtonSize {
  XSmall = 'XSmall',
  Small = 'Small',
  Base = 'Base',
  Medium = 'Medium',
  Large = 'Large',
  XLarge = 'XLarge',
}

export enum ButtonShape {
  Circle = 'Circle',
  Pill = 'Pill',
  Rectangle = 'Rectangle',
  Square = 'Square',
}

export enum ButtonAction {
  Base = 'Base',
  Primary = 'Primary',
  Secondary = 'Secondary',
  Create = 'Create',
  Destroy = 'Destroy',
  Navigation = 'Navigation',
  Reset = 'Reset',
}

export enum ButtonState {
  Default = 'Default',
  Disabled = 'Disabled',
  Loading = 'Loading',
}
